import { HudIcon, IconType } from '@hud/web-components/Icons/HudIcons';
import { BorderedIcon } from '@hud/web-components/Hud/HeadsUpIssueMenu/HeadsUpIssueMenu';
import React from 'react';
import styled from 'styled-components';
import Tooltip from '@hud/web-components/Tooltip/Tooltip';

interface TitleComponentProps {
  total: number;
}

function TitleComponent({
  title,
  tooltip,
  icon,
  total,
}: TitleComponentProps & { title: string; tooltip: string; icon: IconType }) {
  return (
    <Container>
      <BorderedIcon size="30px" icon={icon} />
      {title} ({total})
      <CenteredTooltip openDelay={0} description={tooltip}>
        <HudIcon icon="webviewMenu.info" size="16px" />
      </CenteredTooltip>
    </Container>
  );
}

const CenteredTooltip = styled(Tooltip)`
  display: flex;
  align-items: center;
`;

export function MutedTitleComponent({ total }: TitleComponentProps) {
  return (
    <TitleComponent
      title="Muted endpoints"
      tooltip="These endpoints are monitored and Hud provides Heads-Up for them in the IDE and the web, but no Slack notifications are sent for them"
      icon="other.bellDisabled"
      total={total}
    />
  );
}
export function UnmonitoredTitleComponent({ total }: TitleComponentProps) {
  return (
    <TitleComponent
      title="Unmonitored endpoints"
      tooltip="These endpoints aren’t monitored at all"
      icon="other.ekgDisabled"
      total={total}
    />
  );
}

const Container = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;
